<template>
  <form
    method="post"
    action=""
    class="form-group mt-5"
    @submit.prevent="onSubmit"
    @keydown="formRef.errors.clear($event.target.name)"
  >
    <div id="loader" v-if="loading">
      <div class="spinner"></div>
    </div>

    <div class="alert alert-success" role="alert" v-if="answer">
      {{ answer }}
    </div>
    <div class="alert alert-warning" role="alert" aria-live="assertive" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <div v-if="answer" class="row">
      <div class="col-sm-8 back-link">
        <a href="/login">Take me to login</a>
      </div>
    </div>
    <div class="row" v-else>
      <div class="col-sm-10">
        <h1>Create new password</h1>

        <p>Create your new password below.</p>
        <p>
          The password must contain at least 8 characters, a lower case letter,
          upper case letter, number and one special character. It must also not
          contain any part of your username.
        </p>

        <div class="form-group">
          <label class="form-label"> New Password </label>

          <input
            type="password"
            class="form-control"
            id="password"
            name="password"
            v-model="formRef.password"
          />
        </div>

        <div class="form-group">
          <label> Confirm new password </label>

          <input
            type="password"
            class="form-control"
            id="password_confirmation"
            name="password_confirmation"
            v-model="formRef.password_confirmation"
          />
        </div>

        <div class="mt-4">
          <button
            class="btn btn-primary"
            data-cy="btn-create-new-password"
            :disabled="formRef.errors.any()"
          >
            <span class="bl-submit-text">Create new password</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script setup>
import Form from "../Form.js";
import { ref, markRaw } from "vue";

const errorMessage = ref('')
const loading = ref(false)
const answer = ref('')

let formRef = markRaw(ref(new Form({
  password: "",
  password_confirmation: "",
  _method: "POST"
})))

function onSubmit() {
    if (!formRef.value.password) {
      return (errorMessage = "Please enter password.");
    }
    if (!formRef.value.password_confirmation) {
      return (errorMessage = "Please enter password confirmation.");
    }
    if (formRef.value.password_confirmation !== formRef.value.password) {
      return (errorMessage.value =
        "Password confirmation and password does not match, please try again.");
    }
    (loading.value = true),
      formRef.value
        .post("/set-new-password/" + tokenId)
        .then(
          (response) => (
            (loading.value = false),
            (errorMessage.value = response["errors"]),
            (answer.value = response["results"]["answer"])
          )
        );
  }
</script>
